import React, { useContext, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { FaAngleRight } from 'react-icons/fa';
import { Colors, Height } from '../../../scss/common/style';
import MyContext from '../../../services/context';

export default function WelcomePage() {
  const history = useHistory();
  const context = useContext(MyContext);
  useEffect(() => {
    // Update the document title using the browser API
    if (context.user?.isAuthenticated === true) {
      history.push('/home');
    }
  }, []);

  return (
    <div className="container-fluid h-100">
      <div className="row align-items-center h-100">
        <div className="col-sm-8 col-md-5 col-lg-4 col-xl-3 mx-auto">
          <StyledInner className="jumbotron ak-jumbotron">
            <h2>Svila</h2>
            <StyledP>Trading Management Solution</StyledP>
            <Link className="btn ak-bg-btn" to="/login">
              Login
              <FaAngleRight />
            </Link>
          </StyledInner>
        </div>
      </div>
    </div>
  );
}

const StyledP = styled.p`
  margin-bottom: ${Height.mb50};
`;

const StyledInner = styled.div`
  margin-top: ${Height.mt50};
  text-align: center;
  background-color: ${Colors.white};
  border-radius: 0;
`;
